"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormFromType = exports.getRenderableFormTypeOptions = void 0;
const AllOpeningsSvgForm_1 = require("./AllOpeningsSvgForm");
const CutSvgForm_1 = require("./CutSvgForm");
const DebugSvgForm_1 = require("./DebugSvgForm");
const FilePreviewSvgForm_1 = require("./FilePreviewSvgForm");
const OpeningsPrintSvgForm_1 = require("./OpeningsPrintSvgForm");
const OpeningStickerPreviewSvgForm_1 = require("./OpeningStickerPreviewSvgForm");
const OutputTypeDemonstrationForm_1 = require("./OutputTypeDemonstrationForm");
const PhotomapsDotComProductSvgForm_1 = require("./PhotomapsDotComProductSvgForm");
const RegionCompletionSvgForm_1 = require("./RegionCompletionSvgForm");
const SimpleMessageForm_1 = require("./SimpleMessageForm");
const TblProductSvgForm_1 = require("./TblProductSvgForm");
const stringUtils_1 = require("../../../../lib/stringUtils");
const OpeningSuggestionSvgForm_1 = require("./OpeningSuggestionSvgForm");
/**
 * Renderable Inputs
 *
 * How to add a new set of inputs (form) for a renderable (eg. a map preview SVG).
 *  Step 1. Create a new form in this directory folder with the name <RenderableName>Form.tsx.
 *  Step 2. Add the form to the RenderableTypesToFormMap map here.
 */
const RenderableTypesToFormMap = {
    all_openings: AllOpeningsSvgForm_1.AllOpeningsSvgForm,
    cut: CutSvgForm_1.CutSvgForm,
    debug: DebugSvgForm_1.DebugSvgForm,
    file_preview: FilePreviewSvgForm_1.FilePreviewSvgForm,
    opening_sticker_preview: OpeningStickerPreviewSvgForm_1.OpeningStickerPreviewSvgForm,
    openings_print: OpeningsPrintSvgForm_1.OpeningsPrintSvgForm,
    output_type_demonstration: OutputTypeDemonstrationForm_1.OutputTypeDemonstrationForm,
    opening_suggestion: OpeningSuggestionSvgForm_1.OpeningSuggestionSvgForm,
    photomaps_product: PhotomapsDotComProductSvgForm_1.PhotomapsDotComProductSvgForm,
    region_completion: RegionCompletionSvgForm_1.RegionCompletionSvgForm,
    simple_message: SimpleMessageForm_1.SimpleMessageForm,
    tbl_product: TblProductSvgForm_1.TblProductSvgForm,
};
const BusinessSpecificRenderableType = {
    pm: ["photomaps_product"],
    tbl: ["tbl_product"],
};
function getRenderableFormTypeOptions(businessId) {
    return Object.keys(RenderableTypesToFormMap)
        .filter(type => isAvailableForBusiness(type, businessId))
        .map(type => ({
        label: (0, stringUtils_1.ucWords)(type.replace(/_/g, " ")),
        value: type,
    }));
}
exports.getRenderableFormTypeOptions = getRenderableFormTypeOptions;
function getFormFromType(type) {
    return RenderableTypesToFormMap[type];
}
exports.getFormFromType = getFormFromType;
function isAvailableForBusiness(testType, testBusinessId) {
    if (Object.entries(BusinessSpecificRenderableType).some(([businessId, types]) => businessId != testBusinessId && types.includes(testType))) {
        return false;
    }
    return true;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zYW5kYm94L2lucHV0cy9mb3Jtcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSw2REFBMEQ7QUFDMUQsNkNBQTBDO0FBQzFDLGlEQUE4QztBQUM5Qyw2REFBMEQ7QUFDMUQsaUVBQThEO0FBQzlELGlGQUE4RTtBQUM5RSwrRUFBNEU7QUFDNUUsbUZBQWdGO0FBQ2hGLHVFQUFvRTtBQUNwRSwyREFBd0Q7QUFDeEQsMkRBQXdEO0FBRXhELDZEQUFzRDtBQUN0RCx5RUFBc0U7QUFFdEU7Ozs7OztHQU1HO0FBRUgsTUFBTSx3QkFBd0IsR0FBMkM7SUFDdkUsWUFBWSxFQUFFLHVDQUFrQjtJQUNoQyxHQUFHLEVBQUUsdUJBQVU7SUFDZixLQUFLLEVBQUUsMkJBQVk7SUFDbkIsWUFBWSxFQUFFLHVDQUFrQjtJQUNoQyx1QkFBdUIsRUFBRSwyREFBNEI7SUFDckQsY0FBYyxFQUFFLDJDQUFvQjtJQUNwQyx5QkFBeUIsRUFBRSx5REFBMkI7SUFDdEQsa0JBQWtCLEVBQUUsbURBQXdCO0lBQzVDLGlCQUFpQixFQUFFLDZEQUE2QjtJQUNoRCxpQkFBaUIsRUFBRSxpREFBdUI7SUFDMUMsY0FBYyxFQUFFLHFDQUFpQjtJQUNqQyxXQUFXLEVBQUUscUNBQWlCO0NBQy9CLENBQUM7QUFFRixNQUFNLDhCQUE4QixHQUdoQztJQUNGLEVBQUUsRUFBRSxDQUFDLG1CQUFtQixDQUFDO0lBQ3pCLEdBQUcsRUFBRSxDQUFDLGFBQWEsQ0FBQztDQUNyQixDQUFDO0FBT0YsU0FBZ0IsNEJBQTRCLENBQzFDLFVBQStCO0lBSy9CLE9BQU8sTUFBTSxDQUFDLElBQUksQ0FBQyx3QkFBd0IsQ0FBQztTQUN6QyxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxzQkFBc0IsQ0FBQyxJQUFzQixFQUFFLFVBQVUsQ0FBQyxDQUFDO1NBQzFFLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7UUFDWixLQUFLLEVBQUUsSUFBQSxxQkFBTyxFQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLEdBQUcsQ0FBQyxDQUFDO1FBQ3ZDLEtBQUssRUFBRSxJQUFJO0tBQ1osQ0FBQyxDQUFDLENBQUM7QUFDUixDQUFDO0FBWkQsb0VBWUM7QUFFRCxTQUFnQixlQUFlLENBQUMsSUFBb0I7SUFDbEQsT0FBTyx3QkFBd0IsQ0FBQyxJQUFJLENBQUMsQ0FBQztBQUN4QyxDQUFDO0FBRkQsMENBRUM7QUFFRCxTQUFTLHNCQUFzQixDQUM3QixRQUF3QixFQUN4QixjQUFrQztJQUVsQyxJQUNFLE1BQU0sQ0FBQyxPQUFPLENBQUMsOEJBQThCLENBQUMsQ0FBQyxJQUFJLENBQ2pELENBQUMsQ0FBQyxVQUFVLEVBQUUsS0FBSyxDQUFDLEVBQUUsRUFBRSxDQUN0QixVQUFVLElBQUksY0FBYyxJQUFJLEtBQUssQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDLENBQzNELEVBQ0Q7UUFDQSxPQUFPLEtBQUssQ0FBQztLQUNkO0lBQ0QsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDIn0=